import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Code, Smartphone, CheckCircle, Database } from 'lucide-react';
import { services, testimonials } from '../mockData';

const Home = () => {
  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Transforming Ideas into
              <span className="hero-highlight"> Digital Solutions</span>
            </h1>
            <p className="hero-description">
              StoryBox Solutions delivers world-class software development, mobile applications, 
              quality assurance, and data management services to help your business thrive in the digital age.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn-primary">
                Get Started
                <ArrowRight size={20} />
              </Link>
              <Link to="/about" className="btn-secondary">
                Learn More
              </Link>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwwfHx8fDE3NjIyMzcyMDN8MA&ixlib=rb-4.1.0&q=85"
              alt="Team collaboration"
              className="hero-img"
            />
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-section">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive IT solutions tailored to your business needs
          </p>
        </div>
        <div className="services-grid">
          {services.map((service) => {
            const IconComponent = service.icon === 'Code' ? Code : 
                                 service.icon === 'Smartphone' ? Smartphone :
                                 service.icon === 'CheckCircle' ? CheckCircle : Database;
            return (
              <Link to={`/services/${service.id}`} key={service.id} className="service-card">
                <div className="service-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-desc">{service.shortDesc}</p>
                <span className="service-link">
                  Learn More <ArrowRight size={16} />
                </span>
              </Link>
            );
          })}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-section">
        <div className="why-content">
          <div className="why-image">
            <img 
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85"
              alt="Corporate office"
              className="why-img"
            />
          </div>
          <div className="why-text">
            <h2 className="why-title">Why Choose StoryBox Solutions?</h2>
            <p className="why-description">
              With over a decade of experience in delivering cutting-edge IT solutions, 
              we combine technical expertise with business acumen to drive your success.
            </p>
            <ul className="why-list">
              <li className="why-item">
                <CheckCircle className="why-icon" size={20} />
                <span>Experienced team of certified professionals</span>
              </li>
              <li className="why-item">
                <CheckCircle className="why-icon" size={20} />
                <span>Proven track record with 500+ successful projects</span>
              </li>
              <li className="why-item">
                <CheckCircle className="why-icon" size={20} />
                <span>Agile methodology ensuring timely delivery</span>
              </li>
              <li className="why-item">
                <CheckCircle className="why-icon" size={20} />
                <span>24/7 support and maintenance services</span>
              </li>
              <li className="why-item">
                <CheckCircle className="why-icon" size={20} />
                <span>Competitive pricing with no hidden costs</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="section-header">
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">
            Trusted by leading companies across industries
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div>
                  <p className="testimonial-name">{testimonial.name}</p>
                  <p className="testimonial-position">{testimonial.position}, {testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Start Your Project?</h2>
          <p className="cta-description">
            Let's discuss how we can help transform your business with innovative technology solutions.
          </p>
          <Link to="/contact" className="btn-cta">
            Contact Us Today
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
